module.exports = __webpack_public_path__ + "img/flower1.5fd41b70.svg";